import {observer} from "mobx-react";
import * as React from "react";
import {observable} from "mobx";
import {UIState} from "data/UIState";
import * as ReactDOM from "react-dom";

interface Props {
  children: any;
  title: string;
}

/**
 * Full browser chart display
 */
@observer
export class ChartModal extends React.Component<Props> {
  @observable currentGraph: number = 0;

  constructor(props:Props) {
    super(props);
    UIState.POJSshowFullBrowserMask();
  }

  handleCloseChartModal = () => {
    UIState.POJShideFullBrowserMask();
    setTimeout(() => {
      ReactDOM.render(<span></span>, document.getElementById('fullbrowserbody'))
    }, 500)
  }

  showPreviousGraph = () => {
    this.currentGraph = this.currentGraph - 1;
  }

  showNextGraph = () => {
    this.currentGraph = this.currentGraph + 1;
  }

  render() {
    return (
      <div className="chart">
        {this.props.children[this.currentGraph]}
        <div className="title"><i className="icon-graph"></i> {this.props.title}</div>
        <div className="button close no-print" onClick={this.handleCloseChartModal}>EXIT</div>
        {this.currentGraph > 0 &&
          <a className="previous no-print" onClick={this.showPreviousGraph}><i className="fa fa-angle-left"></i></a>}
        {this.currentGraph < this.props.children.length - 1 &&
          <a className="next no-print" onClick={this.showNextGraph}><i className="fa fa-angle-right"></i></a>}
      </div>
    );
  }
}
